import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DetailsListConfig, DetailsListItem, DetailsListItemType } from './detailslist.interface';
import { DatePipe, DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-detailslist',
  templateUrl: './detailslist.component.html',
  imports: [DecimalPipe, DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsListComponent {
  readonly config = input<DetailsListConfig>({ items: [] });
  readonly rowclick = output<DetailsListItem>();

  protected readonly DetailsListItemType = DetailsListItemType;
}
